/**
 * Created by Rodrigo Quesada on 30/03/17.
 */
import {Work} from '../../../../domain/model/work/history/work.model';
import {MilitaryExperience} from '../../../../domain/model/work/military/military-experience.model';
import {formatMonthYear, separatedBy, separatedBySpace, toOrderValue} from '../../../shared/utils';

//region Other Classes
export type WorkType = Work | MilitaryExperience;

export enum WorkTypeId {WORK = 1, MILITARY}

abstract class WorkEntryData {
    type: WorkTypeId;
    position?: string;
    facility?: string;
    address?: string;
    address2?: string;
    dateFrom?: string;
    dateTo?: string;

    constructor(workType: WorkEntryType<any>) {
        this.type = workType.id;
    }
}

abstract class WorkEntryType<T extends WorkType> {

    constructor(readonly id: WorkTypeId, private readonly _modelType: new () => T) {
    }

    isType(model: WorkType): model is T { return model instanceof this._modelType; }

    abstract toEntryData(model: T): Partial<WorkEntryData>

    abstract orderValueFor(model: T): number
}

class NormalWorkEntryType extends WorkEntryType<Work> {

    constructor() { super(WorkTypeId.WORK, Work); }

    toEntryData(model: Work): Partial<WorkEntryData> {
        const address = model.address;
        const duration = model.duration;

        return <Partial<WorkEntryData>>{
            position: model.positionHeld,
            facility: model.facility,
            address: address.address1,
            address2: separatedBySpace(separatedBy(', ', address.city, address.stateOrProvince), address.postalCode),
            dateFrom: formatMonthYear(duration.from),
            dateTo: !duration.upToPresent ? formatMonthYear(duration.to) : 'Present'
        };
    }

    orderValueFor(model: Work): number {
        const duration = model.duration;
        return toOrderValue(duration.to, duration.upToPresent);
    }
}

class MilitaryWorkEntryType extends WorkEntryType<MilitaryExperience> {

    constructor() { super(WorkTypeId.MILITARY, MilitaryExperience); }

    toEntryData(model: MilitaryExperience): Partial<WorkEntryData> {
        const duration = model.duration;

        return <Partial<WorkEntryData>>{
            facility: 'Military Service',
            dateFrom: formatMonthYear(duration.from),
            dateTo: !duration.upToPresent ? formatMonthYear(duration.to) : 'Present'
        };
    }

    orderValueFor(model: MilitaryExperience): number {
        const duration = model.duration;
        return toOrderValue(duration.to, duration.upToPresent);
    }
}
//endregion

const workTypes: WorkEntryType<any>[] = [
    new NormalWorkEntryType(),
    new MilitaryWorkEntryType()
];

export class WorkEntry extends WorkEntryData {

    private _orderValue: number;

    constructor(work: WorkType) {
        const workType = workTypes.find(it => it.isType(work))!;
        super(workType);

        Object.assign(this, workType.toEntryData(work));

        this._orderValue = workType.orderValueFor(work);
    }

    compareTo(other: WorkEntry) {
        //reverse order from latest/null to oldest
        return -(this._orderValue - other._orderValue);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/cv/download/document/work-entry.class.ts